import React from "react"

import { ChildSelector } from "../../helpers/ChildSelector"

import WPImage, { DISPLAY_MODE } from "../_base/WPImage"

import * as introStyles from "../../styles/world_championships/Intro.module.css"

function Intro(props) {
  const { content } = props

  const title = ChildSelector.select(
    content,
    `title`,
    ChildSelector.SELECTOR_TYPE.TEXT,
  )

  const title2 = ChildSelector.select(
    content,
    `title2`,
    ChildSelector.SELECTOR_TYPE.TEXT,
  )

  const title3 = ChildSelector.select(
    content,
    `title3`,
    ChildSelector.SELECTOR_TYPE.TEXT,
  )

  const text = ChildSelector.select(
    content,
    `content`,
    ChildSelector.SELECTOR_TYPE.TEXT,
  )

  const text2 = ChildSelector.select(
    content,
    `content2`,
    ChildSelector.SELECTOR_TYPE.TEXT,
  )
  const text3 = ChildSelector.select(
    content,
    `content3`,
    ChildSelector.SELECTOR_TYPE.TEXT,
  )

  const postScript = ChildSelector.select(
    content,
    `post-script`,
    ChildSelector.SELECTOR_TYPE.TEXT,
  )

  const youtubeVideos = ChildSelector.select(
    content,
    `youtube-video`,
    ChildSelector.SELECTOR_TYPE.ARRAY,
  )

  const titles = [title, title2, title3]
  const texts = [text, text2, text3]

  return (
    <div className="container-fluid">
      <div className={`row ${introStyles.wrapper}`}>
        <div className={`col-lg-10 col-12 ${introStyles.innerWrapper}`}>
          {youtubeVideos &&
            Array.isArray(youtubeVideos) &&
            youtubeVideos.map((v, i) => (
              <div key={i} className={`row ${introStyles.content}`}>
                <div className={`col-lg-6 col-12 ${introStyles.description}`}>
                  <h2>{titles[i]}</h2>
                  <p>{texts[i]}</p>
                </div>
                <div className={`col-lg-6 col-12 ${introStyles.videoSection}`}>
                  <div className={`row ${introStyles.videoWrapper}`}>
                    <div
                      className={`col-12 ${introStyles.video}`}
                      dangerouslySetInnerHTML={{ __html: v }}
                    />
                  </div>
                </div>
              </div>
            ))}
        </div>

        <div
          className={`col-lg-2 d-lg-flex d-none ${introStyles.illustration}`}
        >
          <WPImage
            holder={content}
            selector={`media-asset`}
            mode={DISPLAY_MODE.normal}
            className={`${introStyles.illustrationImage}`}
          />
        </div>
      </div>
      <div className={`row ${introStyles.postscript}`}>
        <div className="col-lg-12">
          <p>{postScript}</p>
        </div>
      </div>
    </div>
  )
}

export default Intro
